export default {
  team: {
    sendVerification: "Send verification email",
    checkVerification: "I’ve verified my email",
    verificationSent: "Verification email sent. Follow its link, then return here.",

    rsvpIdentity: "Sign in with the verified email address on your guest invitation to respond. RSVP access does not grant access to the organising team.",
    rsvpNoMatch: "No active RSVP invitation matches this email address. Use the invited account or ask the organiser to check your email address.",
    legacyLink: 'This older sharing link or PIN no longer grants team access. Ask the event owner to invite your email address, then open Invitations received.',
    switchAccount: 'Use another account',
    unknownLegacy: 'Old access without a reliable email address — confirm it with the person.',
    sectionDenied: 'This section is not included in your access. Ask the owner to change your permissions.',
  "title": "Team & access",
  "description": "Choose who can help with this event and which sections they can access.",
  "myInvitations": "Invitations received",
  "ownerOnly": "Only the event owner can manage the team. Select an event you own to invite someone.",
  "invite": "Invite someone",
  "retry": "Try again",
  "members": "People with access",
  "owner": "Owner",
  "noMembers": "You are the only person with access. Invite someone when you are ready.",
  "editAccess": "Edit access",
  "remove": "Remove access",
  "invitations": "Invitations",
  "noInvitations": "No pending invitations.",
  "pending": "Awaiting acceptance",
  "cancelled": "Cancelled",
  "expired": "Expired",
  "cancelInvite": "Cancel invitation",
  "guestAccess": "What about guests and old links?",
  "guestHelp": "Team access is for people helping you organise. It does not send guest invitations or manage RSVP responses. Old PINs and sharing links do not grant access to the new team system.",
  "legacy": "{{count}} old access records need review. Re-invite trusted people by email with the sections they need.",
  "removeHelp": "This person will lose access to this event. Their existing contributions will remain.",
  "cancelHelp": "This cancels the invitation and removes access if it has already been accepted. Existing contributions remain.",
  "loadError": "Unable to load team access. Please try again.",
  "actionError": "Unable to save this change. Check your connection and try again.",
  "email": "Email address",
  "role": "Access level",
  "view": "Can view",
  "edit": "Can edit",
  "roleHelp": "Can view: read only. Can edit: add and update items. Only the owner can delete items or manage access.",
  "sections": "Which sections?",
  "tasks": "Tasks",
  "guests": "Guests",
  "budget": "Budget",
  "timeline": "Timeline",
  "summary": "{{role}} · {{sections}} · {{event}}. Access covers all items in these sections, including future items.",
  "selectSections": "Select at least one section. Budget is shared only if you select it.",
  "identityHelp": "Invitations expire after 7 days. The recipient must sign in with this email address and verify it. Forwarding an email does not give someone else access.",
  "send": "Send invitation",
  "sent": "Invitation sent. You can track it in Team & access.",
  "updated": "Access updated.",
  "deliveryFailed": "The invitation is saved, but the email could not be delivered. The recipient can sign in and open Invitations received.",
  "signIn": "Sign in to see your invitations",
  "verifyEmail": "Verify your email address, then sign in again to view invitations.",
  "accept": "Accept invitation",
  "acceptError": "Unable to accept this invitation. It may have expired or been cancelled.",
  "back": "Back to dashboard",
  "sharedEvent": "Shared with you",
  "openSection": "Open {{section}}",
  "waiting": "Invitation accepted. Loading your event…"
},
  review: {
    "notificationDraft": "Adjust your preferences, then save your changes.",
    "markReadError": "Unable to update notifications. Please try again."
},
  accountFlow: {
    "proTitle": "Your plan: Pro",
    "proHelp": "Manage your events, subscription and invoices here.",
    "manageEvents": "Manage my events",
    "unsaved": "Unsaved changes",
    "instantPreferences": "Preferences apply immediately.",
    "comparePlans": "Compare plans",
    "activeEvent": "Current event",
    "openEvent": "Open",
    "editDetails": "Edit details",
    "switchError": "Unable to switch events. Try again."
},
  organization: {
    "vendorOverview": "Vendor overview",
    "grid": "Grid",
    "noVendors": "No matching vendors",
    "resetHelp": "Change your search or reset filters to see your vendors.",
    "seatingProgress": "{{placed}} seated · {{remaining}} to seat",
    "firstTable": "Create your first table",
    "tableHelp": "Add a table to start placing guests, or use automatic generation to prepare a plan.",
    "addTable": "Add a table"
},
  workflow: {
    "scheduleExists": "Steps already in your schedule will not be added again.",
    "taskView": "Task view",
    "list": "List",
    "kanban": "Board",
    "noTasksMatch": "No matching tasks",
    "resetTaskHelp": "Change your search or reset filters to see your tasks.",
    "previewSchedule": "Preview a sample schedule",
    "scheduleHelp": "This wedding template adds the steps below to your existing schedule. You can then adjust the times and descriptions.",
    "applySchedule": "Add these steps"
},
  journey: {
    "guestActions": "Manage guests",
    "openSeating": "Open seating plan",
    "moreGuestActions": "Sharing, RSVP and more",
    "noGuestResults": "No matching guests",
    "changeGuestSearch": "Change your search or reset filters to see your guests.",
    "firstGuestHelp": "Add your first guest or import your list from a CSV file.",
    "estimatorOptional": "The estimator helps you plan your budget. You can also start with your expenses and return here later.",
    "skipEstimator": "Go to expenses"
},
  planning: {
    "eyebrow": "Your planning space",
    "description": "See what needs attention and plan at your own pace.",
    "actions": "Planning actions",
    "tasks": "View my tasks",
    "guests": "Guests",
    "budget": "Budget",
    "pendingCount": "{{count}} to do",
    "completedCount": "{{count}} completed",
    "noDueDate": "No due date",
    "overdue": "Overdue",
    "allDone": "All caught up: every task is complete."
},
  title: "Dashboard",
  welcome: "Welcome",
  overview: "Overview",
  statistics: "Statistics",
  recentActivity: "Recent activity",
  quickAccess: "Quick access",
  settings: "Settings",
  help: "Help",
  documentation: "Documentation",
  feedback: "Feedback",
  daysLeft: "{{days}} days left",
  progress: {
    daysLeft: "{{count}} days remaining"
  },
  overallProgress: "Overall Progress",
  tasksCompleted: "Tasks Completed",
  guestsConfirmed: "Guests Confirmed",
  budgetUsed: "Budget Used",
  "Arrivée des invités": "Guest Arrival",
  "Cérémonie": "Ceremony",
  Cocktail: "Cocktail",
  "Dîner": "Dinner",
  "Soirée": "Party",
  "Préparation": "Preparation",
  tasks: {
    title: "Tasks",
    viewAll: "View all tasks",
    empty: {
      title: "No tasks",
      description: "You don't have any tasks yet",
      action: "Add a task"
    },
    pending: "Pending tasks",
    completed: "Completed tasks",
    noPending: "No pending tasks",
    categories: {
      legal: "Administrative",
      venue: "Venue",
      other: "Other",
      planning: "Planning",
      guests: "Guests"
    }
  },
  guestsWidget: {
    title: "Guests",
    confirmed: "Confirmed",
    declined: "Declined",
    pending: "Pending",
    total: "Total",
    responseRate: "Response rate",
    estimatedProgress: "Estimated progress",
    manage: "Manage",
    addButton: "Add guests",
    emptyTitle: "No guests",
    emptyDescription: "Start adding your guests",
    children: "Children",
    teens: "Teens"
  },
  budgetWidget: {
    title: "Budget",
    spent: "Spent",
    remaining: "Remaining",
    categories: "Categories",
    progress: "Progress",
    overBudget: "Over budget",
    underBudget: "Under budget",
    onTrack: "On track",
    subtitle: "Budget overview",
    configure: "Configure your budget to see statistics",
    configureButton: "Configure"
  },
  timelineWidget: {
    title: "Timeline",
    subtitle: "Upcoming events",
    empty: "No scheduled events"
  },
  vendorsWidget: {
    title: "Vendors",
    subtitle: "Track your vendors",
    add: "Add",
    addVendor: "Add vendor",
    total: "Total",
    emptyTitle: "No vendors yet",
    emptyDescription: "Start by adding your first vendor to see them here.",
    searchVendors: "Search vendors"
  },
  progressWidget: {
    title: "Progress",
    global: "Overall progress",
    tasks: "Tasks",
    guests: "Guests",
    budget: "Budget",
    checklist: "Checklist",
    daysLeft: "{{count}} days left",
    noData: "No data available"
  },
  checklistWidget: {
    title: "Checklist",
    empty: {
      title: "No tasks",
      description: "Start creating your checklist",
      action: "Create list"
    },
    subtitle: "Your progress",
    noImportant: "No important task"
  },
  weatherWidget: {
    title: "Weather",
    setLocation: "Set location",
    addWeather: "Add weather",
    searchReception: "Search reception venue",
    noData: "No weather data available",
    humidity: "humidity",
    rain: "rain",
    currentConditions: "Current conditions in {{location}}",
    historicalTitle: "Historical data",
    historicalNote: "Historical weather data for your event date"
  },
  notificationsWidget: {
    title: "Notifications",
    empty: "No notifications",
    allRead: "All notifications have been read",
    unread: "{{count}} unread notifications",
    markAsRead: "Mark as read",
    viewAll: "View all notifications"
  },
  errors: {
    loadData: "Error loading data",
    noWeddingFound: "No wedding found",
    toggleChecklist: "Error updating checklist",
    markAsRead: "Error marking as read",
    loadingError: "Error loading data",
    noEventFound: "No event found"
  },
  widgets: {
    progress: "Progress",
    tasks: {
      title: "Tasks",
      emptyTitle: "Start organizing",
      emptyDescription: "Add the first tasks to start organizing your wedding",
      addButton: "Add a task",
      completed: "Completed",
      inProgress: "In progress",
      pending: "To do",
      overdue: "Overdue"
    },
    guests: {
      title: "Guests",
      emptyTitle: "Manage your guests",
      emptyDescription: "Start creating your guest list",
      addButton: "Add a guest",
      confirmed: "Confirmed",
      pending: "Pending",
      declined: "Declined",
      total: "Total"
    },
    budget: {
      title: "Budget",
      emptyTitle: "Manage your budget",
      emptyDescription: "Start tracking your expenses",
      addButton: "Add an expense",
      spent: "Spent",
      remaining: "Remaining",
      total: "Total",
      currency: "€"
    },
    timeline: {
      title: "Timeline",
      emptyTitle: "Create your timeline",
      emptyDescription: "Add key moments of your wedding",
      addButton: "Add an event",
      daysLeft: "{{count}} days remaining",
      today: "Today",
      upcoming: "Upcoming"
    },
    vendors: "Vendors",
    checklist: "Checklist"
  },
  stats: {
    totalGuests: "Total Guests",
    totalTasks: "Total Tasks",
    totalBudget: "Total Budget",
    totalVendors: "Total Vendors",
    tasksCompleted: "Completed tasks",
    guestsConfirmed: "Confirmed guests",
    budgetSpent: "Budget spent",
    daysLeft: "Days left"
  },
  quickActions: {
    addTask: "Add Task",
    addGuest: "Add Guest",
    addExpense: "Add Expense",
    addVendor: "Add Vendor",
    title: "Quick actions",
    addEvent: "Add an event"
  },
  countdown: {
    title: "Countdown",
    noDate: "No date set",
    dayJ: "Days",
    dayJ_zero: "D-Day",
    dayJ_one: "Day",
    dayJ_other: "Days",
    hoursJ: "hours",
    hoursJ_zero: "hour",
    hoursJ_one: "hour",
    hoursJ_other: "hours",
    minutesJ: "minutes",
    minutesJ_zero: "minute",
    minutesJ_one: "minute",
    minutesJ_other: "minutes"
  },
  eventDetails: {
    title: "Event Details",
    subtitle: "{{count}} detail(s) to complete",
    complete: "All details are complete",
    partners: "Partners",
    location: "Location",
    budget: "Budget",
    highPriority: "High priority",
    mediumPriority: "Medium priority",
    lowPriority: "Low priority",
    partner1: "Partner 1",
    partner2: "Partner 2",
    venue: "Venue",
    venuePlaceholder: "Venue name",
    address: "Address",
    addressPlaceholder: "Full address",
    city: "City",
    cityPlaceholder: "City",
    totalBudget: "Total budget",
    guestCount: "Guest count",
    edit: {
      partners: "Edit partners",
      location: "Edit location",
      budget: "Edit budget"
    }
  },
  upcomingTasks: "Upcoming Tasks",
  guestsSummary: "Guests Summary",
  budgetSummary: "Budget Summary",
  noUpcomingTasks: "No upcoming tasks",
  noRecentActivity: "No recent activity",
  customize: "Customize Dashboard",
  layout: "Layout",
  themes: "Themes",
  preferences: "Preferences",
  timeline: {
    examples: {
      preparation: {
        title: "Preparation"
      },
      ceremony: {
        title: "Ceremony"
      },
      cocktail: {
        title: "Cocktail"
      },
      dinner: {
        title: "Dinner"
      },
      party: {
        title: "Party"
      }
    }
  },
  description: "Manage your wedding at a glance",
  noEventSelected: "No event selected",
  subtitle: "Overview of your event",
  gridView: "Grid view",
  listView: "List view",
  usage: "Usage",
  account: {
    title: "Account"
  }
};
